// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {createAdvancedClaimSummaryReport} from '../../shared/repositories';
import reportActions from '../actions-list';
import sharedActions from '../../actions-list';

export const createReport = params =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const criteria = params.criteria;
            const selectedDealers = params.selectedDealers.map(dealer => dealer.account);
            const selectedStatuses = params.selectedStatuses.map(status => status.key);

            const data = await createAdvancedClaimSummaryReport(criteria, selectedDealers, selectedStatuses);

            if (params.reportLength) {

                params.gridApi.deselectAll();

                dispatch({
                    showSelectAll: true,
                    type: reportActions.UPDATE_ADVANCED_CLAIM_SUMMARY_SHOW_SELECT_ALL
                });

            }

            dispatch({
                data,
                type: reportActions.UPDATE_ADVANCED_CLAIM_SUMMARY_REPORT
            });

            dispatch({
                hasNoResult: data.length < 1,
                type: sharedActions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: sharedActions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/action-creators/read-report.js